export enum ShareForTypes {
    User = 1,
    Unit,
    Team,
}